import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './provision-of-unpaid-care.reducer';

export const ProvisionOfUnpaidCareDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const provisionOfUnpaidCareEntity = useAppSelector(state => state.provisionOfUnpaidCare.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="provisionOfUnpaidCareDetailsHeading">
          <Translate contentKey="apiLocationApp.provisionOfUnpaidCare.detail.title">ProvisionOfUnpaidCare</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{provisionOfUnpaidCareEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.provisionOfUnpaidCare.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{provisionOfUnpaidCareEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.provisionOfUnpaidCare.date">Date</Translate>
            </span>
          </dt>
          <dd>{provisionOfUnpaidCareEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.provisionOfUnpaidCare.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{provisionOfUnpaidCareEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.provisionOfUnpaidCare.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{provisionOfUnpaidCareEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.provisionOfUnpaidCare.totalAllUsualResidents">Total All Usual Residents</Translate>
            </span>
          </dt>
          <dd>{provisionOfUnpaidCareEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="providesNoCare">
              <Translate contentKey="apiLocationApp.provisionOfUnpaidCare.providesNoCare">Provides No Care</Translate>
            </span>
          </dt>
          <dd>{provisionOfUnpaidCareEntity.providesNoCare}</dd>
          <dt>
            <span id="provides1To19Hours">
              <Translate contentKey="apiLocationApp.provisionOfUnpaidCare.provides1To19Hours">Provides 1 To 19 Hours</Translate>
            </span>
          </dt>
          <dd>{provisionOfUnpaidCareEntity.provides1To19Hours}</dd>
          <dt>
            <span id="provides20To49Hours">
              <Translate contentKey="apiLocationApp.provisionOfUnpaidCare.provides20To49Hours">Provides 20 To 49 Hours</Translate>
            </span>
          </dt>
          <dd>{provisionOfUnpaidCareEntity.provides20To49Hours}</dd>
          <dt>
            <span id="provides50OrMoreHours">
              <Translate contentKey="apiLocationApp.provisionOfUnpaidCare.provides50OrMoreHours">Provides 50 Or More Hours</Translate>
            </span>
          </dt>
          <dd>{provisionOfUnpaidCareEntity.provides50OrMoreHours}</dd>
        </dl>
        <Button tag={Link} to="/provision-of-unpaid-care" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/provision-of-unpaid-care/${provisionOfUnpaidCareEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProvisionOfUnpaidCareDetail;
